const getPatientName = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return `${patient['Last Name']}, ${patient['First Name']}`.toUpperCase();
};

export default getPatientName;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientName.js